import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
export const componentStyles = new String(`.slim-logos-component.jsx-daca6c89ab4a1b55{max-width:${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH + "px"};margin:auto}`);
componentStyles.__hash = "daca6c89ab4a1b55";
